import { useNavigate, useSearchParams } from 'react-router-dom';
import { Download, LogIn, Rocket } from 'lucide-react';
import { Button } from '@/components/landing';

const steps = [
  { icon: Download, title: "Install extension", desc: "Add Mindstream to your Chrome browser." },
  { icon: LogIn, title: "Sign in with Google", desc: "Connect your Gmail account (read-only)." },
  { icon: Rocket, title: "Start using Mindstream", desc: "Your execution dashboard is ready." },
];

export default function WelcomeBeta() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const source = searchParams.get('source');
  const isFreeBeta = source === 'free_beta';
  const isInviteCheckout = source === 'invite_checkout' || (!!sessionId && !source);
  const isValidSuccess = isFreeBeta || isInviteCheckout;

  if (!isValidSuccess) {
    return (
      <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-4">No beta activation found</h1>
          <p className="text-slate-500 mb-8">
            It looks like you haven't completed beta activation yet. Please use your invite code to get started.
          </p>
          <button
            onClick={() => navigate('/')}
            className="text-indigo-600 hover:text-indigo-700 font-medium"
          >
            Return to homepage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      <div className="max-w-xl w-full text-center">
        <div className="mb-8 flex justify-center">
          <div className="h-20 w-20 bg-indigo-50 rounded-3xl flex items-center justify-center text-4xl">
            🎉
          </div>
        </div>

        <h1 className="text-3xl font-bold text-slate-900 mb-4">Welcome to Mindstream Beta</h1>
        <p className="text-slate-500 mb-12">
          {isFreeBeta
            ? "Your free beta access is active. Follow these three simple steps to get started."
            : "Your beta access is confirmed. Follow these three simple steps to get started."}
        </p>

        <div className="space-y-6 text-left mb-12">
          {steps.map((step, i) => (
            <div key={i} className="flex gap-6 p-6 rounded-2xl border border-slate-100 hover:border-indigo-100 transition-colors">
              <div className="flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-xl bg-slate-50 text-indigo-600">
                <step.icon className="h-6 w-6" />
              </div>
              <div>
                <h3 className="font-bold text-slate-900">{i + 1}. {step.title}</h3>
                <p className="text-sm text-slate-500">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <Button fullWidth size="lg" href="https://chromewebstore.google.com/detail/mindstream-ai/eldopammibpnbhjjgeelicjndhnkdbhm">
          Install Chrome Extension
        </Button>

        <button
          onClick={() => navigate('/')}
          className="mt-6 text-sm font-medium text-slate-400 hover:text-slate-600 transition-colors"
        >
          Return to home
        </button>
      </div>
    </div>
  );
}
